module.exports = __webpack_public_path__ + "static/media/waiting-robot.a949e272.gif";